import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject } from '@ember/service';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<button type=\'button\' {{on \'click\' this.openGuide}} class=\'{{if this.args.buttonClass this.args.buttonClass \"beebee-help\"}}\'>\n  <FaIcon @icon=\'question-circle\' />\n\n  {{#if this.args.showLabel}}\n    <span>\n      {{if this.args.label this.args.label (t \'Read our guide\')}}\n    </span>\n  {{/if}}\n</button>");

var _class, _descriptor;
let BbHelpWidgetComponent = (_class = class BbHelpWidgetComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "log", _descriptor, this);
  }
  openGuide(event) {
    event.preventDefault();
    if (typeof window.Intercom === 'function' && this.args.articleId) {
      window.Intercom('showArticle', this.args.articleId);
    } else {
      // fallback: apri l'URL esterno se Intercom non è disponibile
      if (this.args.fallbackUrl) {
        window.open(this.args.fallbackUrl, '_blank', 'noopener,noreferrer');
      } else {
        this.log.warn('Intercom non disponibile e nessun fallbackUrl passato.');
      }
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "log", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "openGuide", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openGuide"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbHelpWidgetComponent);

export { BbHelpWidgetComponent as default };
//# sourceMappingURL=bb-help-widget.js.map
